import { useRef, ChangeEvent } from 'react';
// import uploadimg from './image/uploadimg.png';
import * as EditorTypeAll from '../tinymce.d';
import { Image } from 'lucide-react';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const UploadImg = ({ editorInstance }: Props) => {
  const fileInputRef = useRef(null);

  const imgAction = () => {
    console.log(editorInstance);
    if (fileInputRef.current) {
      document.body.click();
      (fileInputRef.current as HTMLInputElement).click();
    }
  };

  const changeImage = (event: ChangeEvent<HTMLInputElement>) => {
    if (event) {
      editorInstance.execCommand('lxFileChangeUploadImage', false, event);
      event.target.value = '';
    }
  };

  return (
    <>
      <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]" onClick={imgAction}>
        {/* <img width="18px" height="18px" src={uploadimg} /> */}
        <Image strokeWidth={1.5} size={18} />
      </div>
      <input
        className="absolute left-[-9999px]"
        onChange={changeImage}
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/*"
      />
    </>
  );
};

export default UploadImg;
